export default __webpack_public_path__ + "static/media/xBlue.ff59d9cf.svg";